var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolasLogoVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_779_2375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.99 5H49.4847L114.647 86.623L108.664 99.271H57.5912L12.99 5Z",
    fill: "url(#paint0_linear_779_2375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.991 47.8498H98.6042L105.44 39.2782H137.044L141.097 30.7145H112.283L119.118 22.143H145.151L153.242 5H116.708L51.6005 86.5765L57.5912 99.271H124.729L114.647 86.623L132.991 47.8498Z",
    fill: "url(#paint1_linear_779_2375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3921 116.422L35.6123 148.964H35.0001L28.8543 116.422H12.5096L9.75833 122.242H21.5383L30.1408 159.303H38.7511L57.4286 116.422H48.3921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.325 128.543C59.2265 128.543 55.15 133.232 54.499 139.447L53.5147 149.406C53.4527 150.103 53.4527 150.553 53.4527 150.739C53.4527 157.846 59.9085 160 65.7442 160C71.89 160 78.772 157.59 79.5702 149.406L80.5545 139.447C80.6165 138.626 80.6165 138.308 80.6165 138.052C80.601 132.534 76.788 128.543 68.325 128.543ZM72.3627 140.625L71.5877 147.918C71.1615 151.909 69.6192 153.56 66.1162 153.56C63.0162 153.56 61.6987 152.227 61.6987 149.119C61.6987 148.933 61.6987 148.615 61.753 147.918L62.528 140.625C62.9542 136.688 64.4887 135.037 67.953 135.037C71.053 135.037 72.3782 136.37 72.3782 139.416C72.4247 139.517 72.4247 139.959 72.3627 140.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.414 159.302H92.5205L97.0697 114.267H88.9555L84.414 159.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.554 128.543C104.51 128.543 100.929 132.914 100.325 139.067L99.1622 150.359C99.1002 151.056 99.1002 151.498 99.1002 151.754C99.1002 156.636 101.805 160 107.889 160C108.492 160.001 109.093 159.915 109.671 159.744L115.933 154.8L115.507 159.303H123.559L126.659 129.24L118.545 129.868C116.679 128.963 114.627 128.509 112.554 128.543ZM116.429 149.917L111.516 151.25C111.115 151.367 110.701 151.43 110.283 151.436C108.811 151.436 107.517 150.615 107.517 148.266C107.517 148.142 107.517 147.693 107.579 147.057L108.354 139.641C108.664 136.719 110.198 135.262 113.267 135.262C114.849 135.217 116.409 135.637 117.754 136.471L116.429 149.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.662 141.16L141.198 140.462C139.842 140.276 139.044 139.641 139.168 138.37L139.23 137.804C139.416 136.215 140.516 135.479 143.655 135.479C146.414 135.479 152.258 136.176 152.258 136.176L152.932 129.132C149.755 128.697 146.551 128.488 143.345 128.504C136.37 128.504 131.914 130.403 131.24 136.812L130.992 139.09C130.953 139.427 130.932 139.766 130.93 140.106C130.877 141.821 131.475 143.493 132.603 144.787C133.731 146.08 135.306 146.9 137.013 147.081L142.547 147.778C143.833 147.964 144.577 148.662 144.453 149.871L144.391 150.436C144.143 152.916 142.299 152.916 139.292 152.916C136.1 152.833 132.918 152.535 129.767 152.025L129.093 159.256C129.093 159.256 135.231 159.953 140.764 159.953C146.964 159.953 151.762 157.737 152.444 151.328L152.684 149.003C152.723 148.689 152.744 148.373 152.746 148.057C152.779 146.355 152.172 144.702 151.046 143.425C149.919 142.148 148.355 141.34 146.662 141.16Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_779_2375",
    x1: 14.4237,
    y1: 3.8375,
    x2: 98.4182,
    y2: 107.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF2431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#73161D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_779_2375",
    x1: 86.832,
    y1: 29.1877,
    x2: 136.114,
    y2: 90.0485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF2431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC202C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_779_2375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 155,
    fill: "white",
    transform: "translate(4 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolasLogoVertical);
export default __webpack_public_path__ + "static/media/volas-logo-vertical.3ec317ed222a595b719ca9a30d1ebc22.svg";
export { ForwardRef as ReactComponent };